import { useContext } from 'react'
import { StoreFrontScriptManagerContext } from '../../context'
import ScriptsTableRow from './ScriptsTableRow'
import DynamicTable from '../../../../components/DynamicTable/DynamicTable'
import { SCRIPT_TABLE_COLUMNS } from '../../utils'

const ScriptsTable = () => {
  const { scriptList, isLoading, onSortingChange, filters, hasWritePermission } = useContext(StoreFrontScriptManagerContext)

  return (
    <DynamicTable
      id='kt_table_scripts'
      data={scriptList}
      sortableColumns={SCRIPT_TABLE_COLUMNS}
      TableRow={ScriptsTableRow}
      loading={isLoading}
      filters={filters}
      onSortingChange={onSortingChange}
      tableClass='table-row-dashed table-row-gray-300 align-middle gs-0 gy-2 mb-15'
      tableHeaderClass='table-row-bordered'
      hasPermission={hasWritePermission}
    />
  )
}

export default ScriptsTable
